"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentToHex = void 0;
exports.percentToHex = (p) => {
    const intValue = Math.round((p / 100) * 255);
    const hexValue = intValue.toString(16);
    return hexValue.padStart(2, "0").toUpperCase();
};
//# sourceMappingURL=percentToHex.js.map